import './correspondence.sass'

import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import axios from 'axios'
import moment from 'moment'
import DocumentTitle from 'react-document-title'

import Spinner from '@components/spinner'
import Button from '@components/Button'
import ArrowBack from '@components/Icon/ArrowBack'
import ArrowForward from '@components/Icon/ArrowForward'

import FroalaEditor from 'react-froala-wysiwyg'
import { withRouter } from 'react-router-dom'

const CORRESPONDENCE_TYPES = {
  EMAIL: 'email',
  CONVERSATION: 'conversation',
}

class Correspondence extends Component {
  constructor(props) {
    super(props)
    this.scrollableRef = React.createRef()
  }

  state = {
    email: null,
    loading: false,
    reply: false,
    subject: '',
    body: '',
    attachments: []
  }

  componentDidMount() {
    const { location } = this.props
    const params = Object.fromEntries(new URLSearchParams(location.search))
    this.props.correspondenceStore.loadPartialData(this.props.projectStore.project.id)
    if (params.id && params.type) {
      this.props.correspondenceStore.getCorrespondenceDetails(params.id, params.type).then(details => {
        if(details) {
          this.setState({ email: details })
        }
      })
    }

  }

  resize = () => {
    this.refs.frame.style.height =
      window.frames[1].document.body.scrollHeight > 0
        ? window.frames[1].document.body.scrollHeight + 35 + 'px'
        : 0
    window.frames[1].document.body.style.overflow = 'scroll'
  }

  onChange = async e => {
    this.setState({ loading: true })
    const a = this.state.attachments
    const file = e.target.files[0]
    const uploadedFile = await this.props.correspondenceStore.upload({
      filename: file.name,
      contentType: file.contentType
    })

    try {
      await axios.put(uploadedFile.link, file, {
        headers: {
          'Content-Type': file.contentType
        }
      })

      a.push({
        filename: file.name,
        contentType: file.contentType,
        path: uploadedFile.path,
        id: uploadedFile.id
      })

      this.setState({ attachments: a, loading: false })
    } catch (error) {
      console.error(error)
      this.setState({ loading: false })
    }
  }

  onCorrespondenceEntryClick = async (message) => {
    const { history } = this.props
    const type = message.conversation_id ? CORRESPONDENCE_TYPES.CONVERSATION : CORRESPONDENCE_TYPES.EMAIL
    const details = await this.props.correspondenceStore.getCorrespondenceDetails(message.id, type)
    history.push(`?id=${message.id}&type=${type}`)
    if(details) {
      this.setState({
        email: details,
        reply: false,
        subject: `RE: ${details.subject}`,
        body: '',
        attachments: [],
        activeId: details.id,
      })
    }
  }

  onListScroll = () => {
    const scrolledToEnd = this.scrollableRef.current.scrollHeight - this.scrollableRef.current.scrollTop <= (this.scrollableRef.current.clientHeight + 100)
    const projectId = this.props.projectStore.project.id
    if (scrolledToEnd && !this.props.correspondenceStore.partialLoad && !this.props.correspondenceStore.isFullyLoaded) {
      this.props.correspondenceStore.loadPartialData(projectId, this.props.correspondenceStore.emails.length)
    }
  }

  render() {
    if (document.querySelector('.fr-box')) {
      document.querySelector('.fr-box').style.boxShadow = 'none'
      if (this.state.formError === 'body') {
        document.querySelector('.fr-box').style.boxShadow =
          '0px 0px 7px 1px #FF0000'
      }
    }

    return this.props.correspondenceStore.loading ? (
      <Spinner />
    ) : (
      <DocumentTitle
        title={`${this.props.projectStore.project.projectName} - Correspondence | Atheneum Partners`}>
        {this.props.correspondenceStore.emails.length > 0 ? (
          <div className="correspondence-wrapper">
            <div className="correspondence-left">
              <h2 className="correspondence-header">Correspondence History</h2>
              <div className="correspondence-list" ref={this.scrollableRef} onScroll={this.onListScroll}>
                <ul>
                  {(this.props.correspondenceStore.emails || []).map(m => {
                    return (
                      <li
                        key={m.conversation_id ? `${CORRESPONDENCE_TYPES.CONVERSATION}-${m.id}` : `${CORRESPONDENCE_TYPES.EMAIL}-${m.id}`}
                        onClick={() => this.onCorrespondenceEntryClick(m)}
                        className={`${JSON.stringify(this.state.email) === JSON.stringify(m)
                          ? 'active'
                          : ''
                          }`}>
                        <div className="direction">
                          {m.from.includes('atheneum') ? (
                            <ArrowBack />
                          ) : (
                            <ArrowForward />
                          )}
                        </div>
                        <div className="subject">{m.subject}</div>
                        <div className="contact">{m.from}</div>
                        <div className="contact">
                            {
                              m.name &&
                              m.name.trim()}
                        </div>
                        <div className="contact">
                            {
                              m.status &&
                              m.status.trim()}
                        </div>
                        <div className="date">
                          {moment(m.createdAt).format('MMMM DD YYYY, HH:mm')}
                        </div>
                      </li>
                    )
                  })}
                </ul>
              </div>
              <h2 className="correspondence-loading-status">
                {this.props.correspondenceStore.partialLoad ? <Spinner /> : this.props.correspondenceStore.loadingMessage}
              </h2>
            </div>
            <div className="correspondence-content">
              {this.props.correspondenceStore.loadingDetails ? (
                  <Spinner />
              ) : 
              (
                <div className="correspondence-body">
                {this.state.email && (
                  <>
                    <div className="subject">
                      <div className="text">{this.state.email.subject}</div>
                      <div className="date">
                        {moment(this.state.email.createdAt).format(
                          'MMMM DD YYYY, HH:mm'
                        )}
                      </div>
                    </div>
                    <div className="contact">
                      <b
                        style={{
                          width: 50,
                          display: 'inline-block',
                          fontWeight: '700'
                        }}>
                        From
                      </b>
                      {this.state.email.from}
                    </div>
                    <div className="contact">
                      <b
                        style={{
                          width: 50,
                          display: 'inline-block',
                          fontWeight: '700'
                        }}>
                        To
                      </b>
                      {this.state.email.to}
                    </div>
                    {this.state.email && this.state.email.attachments && this.state.email.attachments.length > 0 && (
                      <div className="attachment-wrapper">
                        <h4 style={{ margin: 0, paddingBottom: 10 }}>
                          Attachments
                        </h4>
                        {this.state.email.attachments.map((a, i) => {
                          return (
                            <a
                              key={`attachment-${i}`}
                              className="correspondence-attachment"
                              href={`${process.env.REACT_APP_CAPI_SERVICE_URL
                                }/download?a=${a.id}&token=${localStorage.getItem(
                                  'ngStorage-accessToken'
                                )}`}>
                              {a.filename}
                            </a>
                          )
                        })}
                      </div>
                    )}
                    <div className="body">
                      <iframe
                        ref="frame"
                        className="body-frame"
                        srcDoc={this.state.email.body}
                        onLoad={this.resize}
                        title="Email body"
                      />
                    </div>
                    {!this.state.reply && this.state.email.conversation_id && (
                      <Button
                        className="reply-button"
                        onClick={() => {
                          this.setState({ reply: true })
                          setTimeout(() => {
                            document
                              .querySelector('.reply-wrapper')
                              .scrollIntoView()
                          }, 100)
                        }}>
                        Reply
                      </Button>
                    )}
                    {this.state.reply && (
                      <div className="body reply-wrapper">
                        <div style={{ marginTop: 20 }}>
                          <h3>Subject</h3>
                          <input
                            type="text"
                            className="input-subject"
                            value={this.state.subject}
                            onChange={e =>
                              this.setState({
                                subject: e.target.value,
                                formError: ''
                              })
                            }
                            style={{
                              width: '100%',
                              outline:
                                this.state.formError === 'subject'
                                  ? 'none'
                                  : 'inherit',
                              border:
                                this.state.formError === 'subject'
                                  ? '1px solid red'
                                  : '1px solid'
                            }}
                          />
                        </div>
                        {this.state.formError === 'subject' && (
                          <p style={{ color: 'red', fontSize: 11 }}>
                            Subject field is required.
                          </p>
                        )}
                        <div
                          className="attachment-wrapper"
                          style={{ marginTop: 10 }}>
                          <h4 style={{ margin: 0, paddingBottom: 10 }}>
                            Attachments
                          </h4>
                          {this.state.loading ? (
                            <div style={{ minHeight: 60 }}>
                              <Spinner inline />
                            </div>
                          ) : (
                            <>
                              {this.state.attachments.map((a, i) => {
                                return (
                                  <Button
                                    className="remove-button"
                                    onClick={() => {
                                      this.setState({ loading: true })
                                      this.props.correspondenceStore.deleteFile(
                                        a.id
                                      )
                                      const removedAttachments = []
                                      this.state.attachments.forEach(
                                        (a, index) => {
                                          if (index !== i) {
                                            removedAttachments.push(a)
                                          }
                                        }
                                      )
                                      this.setState({
                                        attachments: removedAttachments,
                                        loading: false
                                      })
                                    }}
                                    disabled={this.state.loading}>
                                    {a.filename}
                                  </Button>
                                )
                              })}
                              <input
                                className="display-none"
                                ref="attachment"
                                type="file"
                                onChange={this.onChange}
                              />
                              <button
                                type="button"
                                onClick={() => this.refs.attachment.click()}
                                className="button button-medium button--secondary"
                                disabled={this.state.loading}
                                style={{ display: 'flex', marginTop: 10 }}>
                                {this.props.label || 'Upload'}
                              </button>
                            </>
                          )}
                        </div>
                        <div style={{ marginTop: 20 }}>
                          <FroalaEditor
                            tag="textarea"
                            config={{
                              key: process.env.REACT_APP_FROALA_KEY,
                              quickInsertTags: [],
                              charCounterCount: false,
                              placeholderText: 'Body',
                              linkInsertButtons: [],
                              height: 300,
                              toolbarButtons: [
                                'paragraphFormat',
                                '|',
                                'formatOL',
                                'formatUL',
                                '|',
                                'insertLink',
                                '|',
                                'clearFormatting',
                                'underline',
                                'italic',
                                'bold'
                              ],
                              htmlAllowedStyleProps: [
                                'text-align',
                                'font-size',
                                'width',
                                'height',
                                'vertical-align',
                                'font-weight',
                                'font-style',
                                'text-decoration',
                                'display',
                                'direction',
                                'letter-spacing',
                                'word-spacing'
                              ],
                              linkEditButtons: [
                                'linkOpen',
                                'linkEdit',
                                'linkRemove'
                              ]
                            }}
                            model={this.state.body}
                            onModelChange={value => {
                              this.setState({
                                body: value,
                                formError: ''
                              })
                            }}
                          />
                        </div>
                        {this.state.formError === 'body' && (
                          <p style={{ color: 'red', fontSize: 11 }}>
                            Body field is required.
                          </p>
                        )}
                        <Button
                          onClick={async () => {
                            if (!this.state.subject) {
                              document.querySelector('.input-subject').focus()
                              this.setState({ formError: 'subject' })
                            } else if (
                              !this.state.body &&
                              this.state.attachments &&
                              this.state.attachments.length === 0
                            ) {
                              this.setState({ formError: 'body' })
                            } else {
                              await this.props.correspondenceStore.reply(
                                this.state.email.id,
                                this.state.subject,
                                this.state.body,
                                this.state.attachments,
                                this.state.email.textExist
                              )
                              await this.props.correspondenceStore.loadPartialData(
                                this.props.location.pathname
                                  .split('/project/')[1]
                                  .replace('/correspondence', ''),
                              )
                              this.setState({
                                reply: false,
                                loading: false,
                                subject: '',
                                body: '',
                                attachments: []
                              })
                            }
                          }}
                          style={{ marginTop: 20 }}
                          disabled={this.state.loading}>
                          Send
                        </Button>
                        <Button
                          onClick={() => {
                            this.setState({ reply: false })
                          }}
                          style={{ marginTop: 20 }}
                          disabled={this.state.loading}>
                          Cancel
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </div>
              )}
            </div>
          </div>
        ) : null}
      </DocumentTitle>
    )
  }
}

export default withRouter(inject(
  'correspondenceStore',
  'projectStore',
  'staticData'
)(observer(Correspondence)))
